import { render, staticRenderFns } from "./album.vue?vue&type=template&id=f6848044&scoped=true"
import script from "./album.vue?vue&type=script&lang=js"
export * from "./album.vue?vue&type=script&lang=js"
import style0 from "./album.vue?vue&type=style&index=0&id=f6848044&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6848044",
  null
  
)

export default component.exports